<template>
  <a-modal
      :title="modalTitle"
      :visible="visible"
      :destroy-on-close="true"
      class="wiring_modal"
      width="1080px"
      :confirm-loading="confirmLoading"
       @cancel="handleCancel">
     <div class="dialog_centent">
       <a-form-model ref="ruleForm"  :colon="false" layout="inline" :rules="rules" class="wiring_form" :model="form"  @submit="handleSubmit">
       <block-title title="计划单信息" :show-line="false">
         <table-edit :data="form" :columns="EditWiringColumns" :table-attribute="tableAttribute" @add="handleAdd" @skuChange='handleSkuChange'>
           <template v-slot:action="scope" >
             <a-button class="wiringDelete" type="link" @click="DeleteRow(scope)">删除</a-button>
           </template>
         </table-edit>
       </block-title>
       <block-title title="排线信息" :show-line="false">
         <div class="wiring_info">
            <a-row >
              <a-col :span="24">
               <a-row>
                  <a-col :span="4">
               <a-form-model-item label="装车拍数">
                 <span class="info_text">{{totalSku}}</span>
               </a-form-model-item>
              </a-col>
              <a-col :span="4">
               <a-form-model-item label="装载率">
                 <span class="info_text">{{volume}}%</span>
                 </a-form-model-item>
              </a-col>
               </a-row>
              </a-col>
              <a-col :span="24">
               <a-form-model-item prop="checkedcCar" label="车长(辆)">
                <a-checkbox-group
                v-model="form.checkedcCar"
                class="wiring_info_checkbox"
                name="checkboxgroup"
                @change="checkboxChange"
                >
                 <a-checkbox v-for="item in carLengthList" :key="item.value" :value="item.value">
                  {{item.label}}<a-input v-if="isInput(item.value)" v-model="form.carList[item.value]" :precision="0" :min="1" type='number' @change="carInput(item)"></a-input>
                  </a-checkbox>
                 </a-checkbox-group>
               </a-form-model-item>
              </a-col>
             
              <a-col :span="8">
                <a-form-model-item prop="line" label="线路">
                  <a-input v-model="form.line" placeholder="请输入线路名称" :max-length="100"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item prop="transportPrice" label="预估费用">
                  <a-input v-model="form.transportPrice" placeholder="请输入预估运费" prefix="￥"></a-input>
                </a-form-model-item>
              </a-col>
          </a-row>

         </div>
       </block-title>
        </a-form-model>
     </div>
      <template slot="footer">
        <div class="action_bar">
          <span>
          <a-button v-if="!notWiring" key="submit" class="danger_button" @click="handleDelete">
          删除
        </a-button>
        </span>
        <span>
          <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="handleSubmit">
          提交
        </a-button>
        </span>
        </div>
      </template>
  </a-modal>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import moment from 'moment';
import tableEdit from './tableEdit.vue'
import {EditWiringColumns,carLengthList,costReg,CAR_LENGTH_VOLUME} from '../const'
import {planUpdate} from '../../api'

const costValidator=(rule, value, callback)=>{
  if(!costReg.test(value)){
    callback('请输入正确的金额')  
  }else{
    callback()
  }
}

  export default {
    components:{
      BlockTitle,
      tableEdit,
    },
    data(){
      return {
        visible:false,
         notWiring:false,
        confirmLoading:false,
        EditWiringColumns,
        CAR_LENGTH_VOLUME,
        totalSku:0,
        volume:0,
        wiringId:1,
        carLengthList,
        tableAttribute:{
          scroll:{x: 'calc(500px + 50%)',y:'200px'},
          pagination:false
        },
        form:{
          checkedcCar:[],
          wiringList:[],
          carList:{}
        },
        rules:{
          checkedcCar:[
             { required: true, message: '请选择需要的车型及数量', trigger: 'change' },
          ],
          line:[
            { required: true, message: '请输入线路', trigger: 'change' },
          ],
          transportPrice:[
             { required: true, message: '请输入预估费用', trigger: 'change' },
             { validator:costValidator, trigger: 'change' },
          ]
        },
        modalTitle:'编辑排线'
      }
    },
    computed:{
      isInput(){
        return (value)=>{
           return this.form.checkedcCar.includes(value)
        }
      },
      
    },
    watch:{
      'form.carList':{
        handler(){
          this.loadingRate()
        },
         deep: true,
      }
    },
    methods:{
      handleSkuChange(row,index){
        this.$set(this.form.wiringList,index,row)
        this.totalPaishu()
      },
      totalPaishu(){
        this.totalSku=0
        this.form.wiringList.forEach(item=>{
         if(item.skuPalletUpper){
          this.totalSku+=Number(item.skuPalletUpper)
         }
        })
        this.loadingRate()
      },
      loadingRate(){
        let checkedVolume=0
        Object.keys(this.form.carList).forEach(item=>{
         checkedVolume+=CAR_LENGTH_VOLUME[item]*this.form.carList[item]
        })
        if(checkedVolume){
          this.volume=((this.totalSku/checkedVolume)*100).toFixed(2)
        }else{
          this.volume=0
        }
      },
      carInput(item){
        this.form.carList[item.value]=this.form.carList[item.value].replace(/[^\d]/g,'')
        if(!this.form.carList[item.value]){
          this.form.carList[item.value]=1
        }
        this.loadingRate()
      },
      checkboxChange(value){
        Object.keys(this.form.carList).forEach(item=>{
          if(!value.includes(item)){
            delete this.form.carList[item]
          }
        })
        value.forEach(item=>{
          this.form.carList[item]=this.form.carList[item]||1
        })
        this.loadingRate()
      },
      handleAdd(){
         if(this.form.wiringList.length===99){
          this.$message.warning('计划单数量不能大于99条')
          return
        }
        this.wiringId+=1
        const {id,...restParmas}=this.form.wiringList[0]
        this.form.wiringList.push( {
            ...restParmas,
            planTime:null,
            supplierCode:'',
            warehouseCode:'',
            skuPallet:'',
            skuAmount:'',
            skuPalletUpper:'',
          })
      },
      DeleteRow(row){
        if(this.form.wiringList.length===1){
          this.$message.warning('计划单数量不能少于1条')
          return
        }
        this.form.wiringList.splice(row.scope.index,1)
        this.totalPaishu()
      },
      show(record,notWiring=false){
        this.visible = true;
        this.notWiring=notWiring
        this.form={
          line:record[0].line||'',
          transportPrice:record[0].transportPrice||'',
          carList:record[0].carList||{},
          checkedcCar:record[0].carList?Object.keys(record[0].carList):[],
        }
        this.form.wiringList= record.map(item=>{
          return {
            ...item,
            skuPallet:item.skuPallet||'',
            planTime:item.planTime?moment(item.planTime):null
          }
        })
        this.totalPaishu()
      },
     async handleSubmit(){
        try {
          await this.$refs.ruleForm.validate()
          this.form.wiringList=this.form.wiringList.map(item=>{
            return {
              ...item,
              loadRate:this.volume,
              transportPrice:this.form.transportPrice,
              line:this.form.line,
              carList:this.form.carList,
              carLength:this.formatCarLength()
            }
          })
          await planUpdate(this.form.wiringList)
          this.$message.success('保存成功')
          this.$emit('cancel')
          this.visible = false;
        } catch (error) {
          console.log(error);
        }
      },
      formatCarLength(){
        const res= Object.keys(this.form.carList).map(key=>{
          return `${key}*${this.form.carList[key]}`
        })
        return res.join()
      },
      handleCancel() {
      this.visible = false;
      this.$emit('cancel')
       },
      handleDelete(){
         this.$emit('delete',this.form.wiringList[0],true)
      }
    
    }
  }
</script>

<style lang="less" scoped>
.wiring_modal {
  /deep/.ant-modal-body {
    padding:0;
    padding-top: 24px;
  }
  /deep/.ant-form-item-label label{
    color: #606266;
  }
}
.dialog_centent {
  padding-bottom: 20px;
}
.wiringDelete {
  color: #ED4934;
}
.wiring_info {
  padding:0 24px;
  .wiring_info_checkbox{
    margin-top: 8px;
    .ant-input {
      width: 64px;
      height: 24px;
      margin-left: 8px;
    }
    /deep/.ant-checkbox-wrapper {
      display: inline-flex;
      flex-direction: row-reverse;
      align-self: center;
      margin-left: 0;
      margin-right: 30px;
      .ant-checkbox {
       top:0.2em;
      }
      .ant-checkbox-checked::after{
        height: auto;
      } 
    }
  }
}
.action_bar {
  display: flex;
  justify-content: space-between;
  .danger_button {
    border: 1px solid #F56C6C;
    color: #F56C6C;
  }
}
.info_text {
  font-weight: 700;
}
</style>